var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.8 61.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f07de6a1-504a-42d6-bbff-84d970132e54{fill:#e4ebf8;}.a384f20f-d06b-4cd5-95b4-5b8e862b0c5e{fill:#fff;}.b7c2d35d-d5a3-4f5a-8946-d677289b0022{font-size:20px;font-family:SegoeUI-Semilight, Segoe UI;font-weight:300;}.feb44279-5647-48c1-af2b-badde91caa20{letter-spacing:-0.03em;}.bcd3f3e8-8d77-4891-80f2-fb2f468aaeda{letter-spacing:-0.01em;}.b9ee4d9a-14cd-4523-be72-91f3bb2e8787{fill:#489dde;}.f7d7d1ce-4b23-4c6e-9121-183902626d87{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.09px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc9e3ad6-b245-403b-b947-a1be34f72559",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f07de6a1-504a-42d6-bbff-84d970132e54",
    d: "M38.3,53.57a22.62,22.62,0,0,1,0-45.24h106a22.62,22.62,0,0,1,0,45.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    d: "M144.3,9.21a21.74,21.74,0,1,1,0,43.48H38.3a21.74,21.74,0,0,1,0-43.48h106m0-1.76H38.3a23.5,23.5,0,0,0,0,47h106a23.5,23.5,0,0,0,0-47Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b7c2d35d-d5a3-4f5a-8946-d677289b0022",
    transform: "translate(67.8 37.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "feb44279-5647-48c1-af2b-badde91caa20"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "bcd3f3e8-8d77-4891-80f2-fb2f468aaeda",
    x: 9.64,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.84,
    y: 0
  }, "orage")), /*#__PURE__*/React.createElement("path", {
    className: "b9ee4d9a-14cd-4523-be72-91f3bb2e8787",
    d: "M31,60.9A30,30,0,1,1,60.9,31,30,30,0,0,1,31,60.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    d: "M31,2A29,29,0,1,1,2,31,29,29,0,0,1,31,2m0-2a31,31,0,1,0,31,31A31,31,0,0,0,31,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    cx: 30.95,
    cy: 30.95,
    r: 9.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    cx: 43.97,
    cy: 49.72,
    r: 2.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    cx: 13.82,
    cy: 22.69,
    r: 2.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a384f20f-d06b-4cd5-95b4-5b8e862b0c5e",
    cx: 40.16,
    cy: 19.75,
    r: 2.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f7d7d1ce-4b23-4c6e-9121-183902626d87",
    cx: 30.95,
    cy: 30.95,
    r: 19.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f7d7d1ce-4b23-4c6e-9121-183902626d87",
    cx: 30.95,
    cy: 30.86,
    r: 14.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f7d7d1ce-4b23-4c6e-9121-183902626d87",
    cx: 30.95,
    cy: 30.95,
    r: 22.85
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.df017cb1.svg";
export { ForwardRef as ReactComponent };